<script>
export let style_container = "";
export let style_loader = "";
export let has_errors = false;
export let loaded = false;
export let loading = undefined;
export let showMessage = true;
export let message = window?.ContentsAll?.ctn_vfAz1k ?? "Cargando...";
export let custom_color = false; // color in HEX, RGB or HSL. pass false to not 

$: if (loading !== undefined) loaded = !loading;

let custom_hex = custom_color ? `--loader-element-custom-color:${custom_color};` : ""
</script>
{#if has_errors == false}
    {#if loaded == false}
        <loader-element class="is-flex {custom_color ? "custom_color" : ""} is-justify-content-center is- is-align-items-center" style="flex-direction: column;{custom_hex}{style_container}">
            <button type="button" class="button is-loading is-outlined is-borderless is-large is-size-1" aria-label="Cargando" style="{style_loader}"></button>
            {#if showMessage}
                <p>
                    {message}
                </p>
            {/if}
        </loader-element>
    {/if}
{/if}
{#if loaded === true && has_errors === false}
    <slot></slot>
{/if}
<style>
.button{
    background: none;
}
.button.is-loading:after{
    border-color: #296fff1c var(--color-secundary) var(--color-secundary) var(--color-primary);
    background: transparent !important;
    background-color: transparent !important;
    border-width: 3.4px;
}
loader-element.custom_color .button.is-loading:after{
    border-color: transparent transparent var(--loader-element-custom-color) var(--loader-element-custom-color);
}
</style>